/*
 * @Description: 转移复制车载设备 配置
 * @Date: 2026-09-16
 */

import { enumToOption } from '@/utils'

// 源企业设备设置：1-直接移除 2-设为暂停
export enum removeSourceEnum {
  直接移除 = 1,
  设为暂停
}
export const removeSourceOption = enumToOption(removeSourceEnum)

// 拼接厂商-型号
const formatModel = (row: any, prefix: string) => {
  const text = [row[`${prefix}DeviceFactory`], row[`${prefix}DeviceMaintain`]]
    .filter(Boolean)
    .join('-')
  return text || '-'
}

// 预览表格配置
export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 是否为斑马纹
    stripe: true,
    // table 的高度（定高约 10 条数据，超出出现纵向滚动条）
    height: 400,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: false,
    // table 索引 label
    indexLabel: '序号',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: false,
    // 总条数
    total: 0,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'sourceCarNo',
      label: '源企业车牌号',
      labelClassName: 'source-col-header',
      width: '140',
      formatter: (row: any) => row.sourceCarNo || '-'
    },
    {
      key: 'sourceDeviceMaintain',
      label: '设备型号',
      width: '160',
      formatter: (row: any) => formatModel(row, 'source')
    },
    {
      key: 'sourceDeviceNo',
      label: '设备编号',
      width: '160',
      formatter: (row: any) => row.sourceDeviceNo || '-'
    },
    {
      key: 'targetCarNo',
      label: '目标企业车牌号',
      labelClassName: 'target-col-header',
      width: '140',
      formatter: (row: any) => row.targetCarNo || '-'
    },
    {
      key: 'targetDeviceMaintain',
      label: '设备型号',
      width: '160',
      formatter: (row: any) => formatModel(row, 'target')
    },
    {
      key: 'targetDeviceNo',
      label: '设备编号',
      width: '160',
      formatter: (row: any) => row.targetDeviceNo || '-'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}
